<template>
    <div class="session" @error="errorHandler">
        <publisher
            v-if="session"
            :key="sessionId"
            :session="session"
            @error="errorHandler"
            :opts="publisherOpts"
        />
        <transition-group
            class="subscribers"
            name="fade-width"
            tag="div"
        >
            <subscriber
                v-for="stream in streams"
                :key="stream.streamId"
                @error="errorHandler"
                :stream="stream"
                :session="session"
            />
        </transition-group>
    </div>
</template>

<script>
import OT from '@opentok/client';
import Publisher from './Publisher.vue';
import Subscriber from './Subscriber.vue';

import { functions } from '../../../../db'

export default {
    name: 'session',
    components: { Publisher, Subscriber },
    props: ['expoId', 'roomStr', 'convId'],
    data: () => ({
        streams: [],
        session: null,
        apiKey: '',
        sessionId: '',
        token: '',
        isConnected: false,
        publisherOpts: {
            width: 200,
            height: 200,
        }
    }),
    methods: {
        errorHandler(err) {
            console.error(err)
        },
        connectSession() {
            this.session = OT.initSession(this.apiKey, this.sessionId);

            this.session.connect(this.token, err => {
                if (err) {
                    this.errorHandler(err);
                } else {
                    this.isConnected = true
                }
            });

            this.session.on('streamCreated', event => {
                this.streams.push(event.stream);
            });
            this.session.on('streamDestroyed', event => {
                const idx = this.streams.indexOf(event.stream);
                if (idx > -1) {
                    this.streams.splice(idx, 1);
                }
            });
            this.session.on('sessionDisconnected', () => {
                this.isConnected = false
            })
        }
    },
    watch: {
        convId: {
            immediate: true,
            handler(convId) {
                this.apiKey = ''
                this.sessionId = ''
                this.token = ''
                if (this.session && this.isConnected) {
                    this.session.disconnect()
                    return
                }

                var videoinfo = functions.httpsCallable('videoinfo')
                videoinfo({
                    expoId: this.expoId,
                    chatId: this.roomStr.replaceAll('/','-'),
                    convId: convId,
                }).then(result => {
                    this.apiKey = result.data.apiKey
                    this.sessionId = result.data.sessionId
                    this.token = result.data.token
                    this.connectSession()
                })
            }
        }
    },
    beforeDestroy() {
        if (this.session && this.isConnected) {
            this.session.disconnect()
        }
    }
};
</script>

<style lang="scss" scoped>

.session {
    margin-top: 60px;
    min-height: 200px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    ::v-deep .OT_root {
        border-radius: 100px;
        max-height: 200px;
        max-width: 200px;
        margin: 0px 10px 0px 10px;
        pointer-events: none;
        overflow: hidden;
        .OT_edge-bar-item {
            opacity: 0 !important;
        }
        .OT_widget-container {
            border-radius: 100px;
            overflow: hidden;
            .OT_video-element, .OT_video-loading {
                border-radius: 100px;
            }
        }
    }
}

.fade-width-enter-active, .fade-width-leave-active, .fade-width-move {
    transition: all 0.2s ease;
    transition-property: margin opacity max-width transform;
}
.fade-width-enter, .fade-width-leave-to {
    opacity: 0;
    max-width: 0px;
    margin: 0px;
}
.fade-width-enter-to, .fade-width-leave {
    opacity: 1;
    max-width: 200px;
    margin: 0px 10px 0px 10px;
}

</style>